import { cn } from "@gettactic/helpers";

export const inputV2Classes =
  "rounded-lg min-h-[42px] mb-0 mt-0 border-0 focus-visible:ring-0 focus-visible:ring-offset-0 bg-neutral-50 " +
  " [.v2-reservation_&]:mt-0 [.v2-reservation_&]:py-0 [.v2-reservation_&]:text-neutral-1000 [.v2-reservation_&]:text-sm [.v2-reservation_&]:rounded-v2 [.v2-reservation_&]:font-normal";

export const inputV2ClassesOnGray = cn(inputV2Classes, "bg-white");

// z-10 to ensure the icon is above ::after
export const inputIcon = "h-4 w-4 text-neutral-800 z-10";
